import { render, staticRenderFns } from "./Incedence.vue?vue&type=template&id=25d514dd&scoped=true"
import script from "./Incedence.vue?vue&type=script&lang=js"
export * from "./Incedence.vue?vue&type=script&lang=js"
import style0 from "./Incedence.vue?vue&type=style&index=0&id=25d514dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d514dd",
  null
  
)

export default component.exports